export const MINIMUM_NUMBER_OF_DAYS_TO_ANONYMIZE_RESPONDENTS_AFTER = 30;
export const MAXIMUM_NUMBER_OF_DAYS_TO_ANONYMIZE_RESPONDENTS_AFTER = 180;

export const CustomFunctionality = {
  COUNSELORS_INTERESTS_REPORT: 'COUNSELORS_INTERESTS_REPORT',
  STUDENTS_INTERESTS_REPORT: 'STUDENTS_INTERESTS_REPORT',
  INTERESTS_GRAPH_REPORT: 'INTERESTS_GRAPH_REPORT',
  INTERESTS_GRAPH_API: 'INTERESTS_GRAPH_API',
  SIMPLIFIED_CC_REPORTS: 'SIMPLIFIED_CC_REPORTS',
  MINIMUM_MATCH_PERCENTAGE_CC_REPORTS: 'MINIMUM_MATCH_PERCENTAGE_CC_REPORTS',
};

export const UnsettledCommissionType = {
  BETWEEN_GSC_AND_GPI: 'BETWEEN_GSC_AND_GPI',
  BETWEEN_GSC_AND_GP: 'BETWEEN_GSC_AND_GP',
};

export const CreditPlan = {
  STANDARD: 'STANDARD',
  UNLIMITED: 'UNLIMITED',
  NO_LIMIT: 'NO_LIMIT',
};

export const RespondentType = {
  INTERNAL: 'INTERNAL',
  EXTERNAL: 'EXTERNAL',
  ANONYMOUS: 'ANONYMOUS',
};
export const CUSTOM_JOB_MATCH_TYPE = 'CUSTOM';
export const STANDARD_JOB_MATCH_TYPE = 'STANDARD';
export const MINIMUM_CREDIT_COMMISSION_PERCENTAGE = 0;
export const DEFAULT_CREDIT_COMMISSION_PERCENTAGE= 30;
export const MAX_CREDIT_COMMISSION_PERCENTAGE = 60;
export const MINIMUM_COMMISSION_PERCENTAGE = 0;
export const MAX_NO_LIMIT_COMMISSION_PERCENTAGE = 60;
export const DEFAULT_NO_LIMIT_COMMISSION_PERCENTAGE = 30;
export const MAX_SUPER_MATCH_CREDITS_COMMISSION_PERCENTAGE = 20;
export const DEFAULT_SUPER_MATCH_CREDITS_COMMISSION_PERCENTAGE = 10;

export const STRIPE_INVOICE_FOR_BANK_TRANSFER_CREATED = 'STRIPE_INVOICE_FOR_BANK_TRANSFER_CREATED';

export const DEFAULT_EMPTY_CONTENT = '-';

export const SUCCESS = 'success';
export const CANCELLED = 'cancelled';

export const RequiredUserActionType = {
  BUY_SUBSCRIPTION_FOR_ACCOUNT: 'BUY_SUBSCRIPTION_FOR_ACCOUNT',
};

export const SubscriptionStatus = {
  ACTIVE: 'ACTIVE',
  TRIALING: 'TRIALING',
  PAUSED: 'PAUSED',
  INCOMPLETE: 'INCOMPLETE',
  INCOMPLETE_EXPIRED: 'INCOMPLETE_EXPIRED',
  PAST_DUE: 'PAST_DUE',
  CANCELED: 'CANCELED',
  UNPAID: 'UNPAID',
};

export const NumberOfEmployees = {
  SELECTED_BY_CLIENT: 'SELECTED_BY_CLIENT',
  _0_9: '_0_9',
  _10_24: '_10_24',
  _25_49: '_25_49',
  _50_74: '_50_74',
  _75_99: '_75_99',
  _100_249: '_100_249',
  _250_499: '_250_499',
  _500_999: '_500_999',
  _1000_2499: '_1000_2499',
  _2500_4999: '_2500_4999',
  _5000_7499: '_5000_7499',
  _7500_9999: '_7500_9999',
  _10000_14999: '_10000_14999',
  _15000_19999: '_15000_19999',
  _20000_24999: '_20000_24999',
};

export const PaymentMethod = {
  CREDIT_CARD: 'CREDIT_CARD',
  BANK_TRANSFER: 'BANK_TRANSFER',
};

export const PayedBy = {
  PAYED_BY_SELF: 'PAYED_BY_SELF',
  PAYED_BY_PARENT: 'PAYED_BY_PARENT',
};

export const AccountType = {
  GPI: 'GPI',
  SOURCED_CANDIDATES_POOL: 'SOURCED_CANDIDATES_POOL',
  MCP: 'MCP',
  CP: 'CP',
  CLIENT: 'CLIENT',
  GSC: 'GSC',
  GP: 'GP',
  NBM_CLIENT: 'NBM_CLIENT',
  ESSENTIAL: 'ESSENTIAL'
};

export class AssessmentConstants {
  static DISTORTION_STATUS = {
    OK: 'OK',
    NOT_OK: 'NOT_OK',
    NOT_MEASURED: 'NOT_MEASURED',
  };

  static API_URL = {
    REPORT: '/reports/download-reports',
  };

  static MAX_EXPANDS_TIME = 90;

  static ASMT_STATUS = {
    NEW: 'NEW',
    INVITED: 'INVITED',
    STARTED: 'STARTED',
    SUBMITTED: 'SUBMITTED',
    DECLINED: 'DECLINED',
    EXPIRED: 'EXPIRED',
  };

  static REPORT_TYPE = {
    INDIVIDUAL: 'INDIVIDUAL',
    COUNSELING_INTEREST: 'CC_INTERESTS',
    COUNSELING_PERSONALITY: 'CC_PERSONALITY',
    SUMMARY: 'SUMMARY',
    INTERVIEW: 'INTERVIEW',
    MANAGEMENT: 'MANAGEMENT',
    SUMMARY_STANDARD_JOB: 'SUMMARY_STANDARD_JOB',
    INTERVIEW_STANDARD_JOB: 'INTERVIEW_STANDARD_JOB',
    MANAGEMENT_STANDARD_JOB: 'MANAGEMENT_STANDARD_JOB',
    COUNSELORS_INTERESTS_REPORT: 'COUNSELORS_INTERESTS_REPORT',
    STUDENTS_INTERESTS_REPORT: 'STUDENTS_INTERESTS_REPORT',
    INTERESTS_GRAPH_REPORT: 'INTERESTS_GRAPH_REPORT',
    SIMPLIFIED_CC_INTERESTS: 'SIMPLIFIED_CC_INTERESTS',
    SIMPLIFIED_CC_PERSONALITY: 'SIMPLIFIED_CC_PERSONALITY'
  };

  static REPORT_DIMENSION = {
    LOW: 1,
    HIGH: 10,
    OUT_RANGE: 2,
    MATCH_PRIORITY: 3,
    NUM_INTEREST: 3,
  };

  static PERCENT_COLOR_MAP = {
    LVL_0: {
      FLOOR: 0,
      COLOR: 'label-0',
    },
    LVL_2: {
      FLOOR: 2,
      COLOR: 'label-1',
    },
    LVL_3: {
      FLOOR: 3,
      COLOR: 'label-2',
    },
    LVL_4: {
      FLOOR: 4,
      COLOR: 'label-3',
    },
    LVL_5: {
      FLOOR: 5,
      COLOR: 'label-4',
    },
    LVL_6: {
      FLOOR: 6,
      COLOR: 'label-5',
    },
    LVL_7: {
      FLOOR: 7,
      COLOR: 'label-6',
    },
    LVL_8: {
      FLOOR: 8,
      COLOR: 'label-7',
    },
    LVL_9: {
      FLOOR: 9,
      COLOR: 'label-8',
    },
    LVL_10: {
      FLOOR: 10,
      COLOR: 'label-8',
    },
  };

  static INSTRUMENT_TYPES = {
    JPS: 'JPS',
    STD: 'STD',
    C360: 'C360',
  };
}

export class AppConstants {
  static GSC_DASHBOARD_DATE_INPUT_FORMAT = 'Do MMM, YYYY';

  static GSC_DASHBOARD_DATETIME_INPUT_FORMAT = 'Do MMM, YYYY, hh:mm zz';

  static DATE_INPUT_FORMAT = 'YYYY-MM-DD';

  static DATETIME_INPUT_FORMAT = 'YYYY-MM-DD hh:mm:ss A';

  static DEFAULT_LANG = 'en-US';

  static DEFAULT_LOCALE = 'en-US';

  static PAGE_REPORT_URL = '/reports/download-reports';

  static UUID_STR_SEPARATOR = ',';

  static SHORT_LANGUAGE_FORMAT_LENGTH = 2;

  static REPORT_RANKING = 'RANKING';

  static DEF_LOCAL_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
}

export class LanguageAccount {
  static LANGUAGE_JP = 'ja-JP';
}

export class Pagination {
  static DEFAULT_PAGE_SIZE = 25;

  static DEFAULT_PAGE_SIZE_10 = 10;

  static DEFAULT_PAGE_SIZE_50 = 50;

  static DEFAULT_PAGE_SIZE_100 = 100;

  static DEFAULT_PAGE_LISTS = [10, 25, 50, 100];

  static NEXT = 'next';

  static PREV = 'prev';

  static TEMP_JP_SIZE = 200;

  static SHORT_PAGE_SIZE = 10;

  static LIST_DEFAULT_SORT_FIELD = {
    SURVEY_TEMPLATE: 'title',
  };
}

export const REPORT_EXECUTIVE = 'EXECUTIVE_REPORT';

export const TEAM_REPORT = 'TEAM_REPORT';

export const SURVEY_FILE_IMPORT_STATUS = {
  VALID: 'VALID_IMPORT',
  FAILED: 'FAILED_IMPORT',
  ACTIVATIVED: 'ACTIVATED',
};

export const HINT_TYPES = {
  CS: 'cs',
  JPS: 'jps',
};

export const SURVEY_IMPORT_LOG_TYPE = {
  LOG: 'LOG',
  DEF: 'DEF',
};

export const SEARCHING_TIME_DELAY = 300;

export const GRAPHQL_EXCEPTION_CODE = 1001;
export const NOT_FOUND = 404;

export const FALLBACK_LANGUAGES = {
  'ar-SA': 'ar',
  'en-UK': 'en-GB',
  en_US: 'en-US',
  'el-GR': 'el',
  'de-DE': 'de',
  'da-DK': 'da',
  'fr-FR': 'fr',
  'ja-JP': 'ja',
  'hu-HU': 'hu',
  'no-NO': 'nb',
  no: 'nb',
  'pt-AO': 'pt',
  'ro-RO': 'ro',
  'vi-VN': 'vi',
};

export const FALLBACK_REGIONS = {
  'en-US': 'en',
  en_US: 'en',
  'es-ES': 'es',
  'pt-BR': 'pt',
};

export const APP_ENDPOINT = {
  ADMIN: '/apps/admin/dashboard/',
  SCHEDULING: '/apps/client/dashboard/',
  CREDIT: '/apps/credit/dashboard/',
};

export const ACTIONS = {
  LIST_ACTION: 'LIST_ACTION',
};

export const EXCEPTION_CODE = {
  MISSING_FIELDS: 1,
  DISABLED_LINK: 2,
  GENERAL_ERR: 9,
};
